export { vaultTypeToLabel, isEligibleEarnToken } from './utils'
